import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, styled } from "@mui/material";
import { Link, useRouteMatch } from "react-router-dom";
import { showInfoToast } from "../../../toast/toast-service";
import { theme as themeConstants } from "../../../theme";
import { getSelectedArea } from "../../../services/url-helpers";

// Custom styled components using MUI
const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth: "800px",
  width: "80%",
  height: "50%",
  justifyContent: "space-around",
  alignItems: "center",
  marginLeft: "50px",
  display: "flex",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    marginLeft: "0px",
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    minHeight: "40px",
    padding: "10px 0",
    backgroundColor: "white",
    borderBottom: "1px solid #e0e0e0",
  },
}));

const IconTextWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "50px",
  marginRight: "50px",
  textAlign: "center",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    margin: "8px 8px",
  },
}));

const IconText = styled(Box)(({ theme, isSelected }) => ({
  fontWeight: 600,
  fontSize: "24px",
  color: isSelected ? themeConstants.mainColor : "#D2CECE",
  cursor: "pointer",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    fontSize: "16px",
  },
}));

const Line = styled(Box)({
  background: themeConstants.mainColor,
  height: "2px",
  width: "57%",
});

export const CentralNavigationBar = () => {
  const match = useRouteMatch();

  const isAreaSelected = (areaName) => {
    const selectedArea = getSelectedArea(match.path).split("/")[0];

    if (areaName === "teachers") {
      return selectedArea === "teachers" || selectedArea === "home";
    }

    return selectedArea === areaName;
  };

  return (
    <Wrapper>
      <IconTextWrapper
        onClick={() =>
          showInfoToast(<FormattedMessage id={"feature-coming-soon"} />)
        }
      >
        <IconText isSelected={isAreaSelected("content")}>
          <FormattedMessage id={"header.navigation-content"} />
        </IconText>
        {isAreaSelected("content") && <Line />}
      </IconTextWrapper>

      <Link to={`/`} style={{ textDecoration: "none", color: "black" }}>
        <IconTextWrapper>
          <IconText isSelected={isAreaSelected("teachers")}>
            <FormattedMessage id={"general.private-tutoring"} />
          </IconText>
          {isAreaSelected("teachers") && <Line />}
        </IconTextWrapper>
      </Link>
      
      <IconTextWrapper
        onClick={() =>
          showInfoToast(<FormattedMessage id={"feature-coming-soon"} />)
        }
      >
        <IconText isSelected={isAreaSelected("groups")}>
          <FormattedMessage id={"general.study-groups"} />
        </IconText>
        {isAreaSelected("groups") && <Line />}
      </IconTextWrapper>
    </Wrapper>
  );
};
